import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ChannelCreateModal from './ChannelCreateModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  status: state.modal.channelCreateModal
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_CHANNEL_CREATE, false),
  createChannel: actions.channel.createChannel,
  getChannelById: actions.channel.getChannelById
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChannelCreateModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ChannelCreateModal/index.js